export const initialState = {
  myTailoring: [],
  allTailoring: [],
  basketTailoringIds: [],
  auctionTailoring: [],
  auctionTailoringIds: [],
  dealDoneTailoring: [],
  wonTailoring: [],
  lostTailoring: [],
  editTailoring: undefined,
  tailoringDetails: undefined,
  tailoringDetailsId: '',
  customTime: undefined,
  timeStamp: undefined
};

export default function tailoringReducer(state = initialState, action) {
  switch (action.type) {
    case 'TAILORING_FIND_ALLTAILORING': {
      if (action.data) {
        const allTailoring = action.data.allTailoring;

        return {
          ...state,
          allTailoring: allTailoring
        };
      }
      return initialState;
    }
    case 'TAILORING_SET_EDITTAILORING': {
      if (action.data) {
        const editTailoring = action.data;

        return {
          ...state,
          editTailoring: editTailoring
        };
      }
      return initialState;
    }
    case 'TAILORING_SET_TAILORINGDETAILSID': {
      if (action.data) {
        const id = action.data;
        return {
          ...state,
          tailoringDetailsId: id
        };
      }
      return initialState;
    }
    default:
      return state;
  }
}
